import * as React from "react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@components/ui/tooltip";

interface CustomTooltipProps {
  text: string | React.ReactNode;
  children?: React.ReactNode;
  side?: "top" | "bottom" | "left" | "right";
  className?: string;
}

const CustomTooltip: React.FC<CustomTooltipProps> = ({
  text,
  children,
  side = "top",
  className = "",
}) => {
  return (
    <>
      <TooltipProvider delayDuration={0}>
        <Tooltip>
          <TooltipTrigger asChild>{children}</TooltipTrigger>
          <TooltipContent collisionPadding={60} side={side}>
            <div className={className}>{text}</div>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </>
  );
};

export default CustomTooltip;
